export default {
    nl: {
        intro: {
            subtitle: 'MySQL',
            title: 'Database managen.',
            contact: 'Neem contact op',
            image: 'https://23g-website.s3.eu-central-1.amazonaws.com/services/mysql/hero.jpg',
        },
        type: 'MySQL',
        title: 'MySQL: Database beheer voor webapplicaties en analyse',
        description: 'Ontdek MySQL voor efficiënt gegevensbeheer in webtoepassingen en data-analyse. Ideaal voor CMS, CRM, ERP en bedrijfs inzichten.',
        content: [
            {
                type: 'text',
                title: 'MySQL',
                content:
                    'Bij 23G vind je MySQL in de kern van veel van onze projecten. MySQL is een van die sterspelers als het gaat om databases, zoals bij het opslaan en beheren van belangrijke gegevens. Snelle verwerking, betrouwbaarheid en schaalbaarheid maken MySQL een favoriet bij ontwikkelaars, zeker wanneer er grote hoeveelheden data in het spel zijn. Daarnaast is het schaalbaar is voor zowel kleine websites als uitgebreide zakelijke systemen. Een enthousiaste, actieve community van ontwikkelaars staat altijd klaar om te helpen wanneer je ergens tegenaan loopt.',
            },
            {
                type: 'text',
                title: 'MySQL en webtoepassingen',
                content:
                    'Bij 23G vind je MySQL in de kern van veel van onze projecten. MySQL is een van die sterspelers als het gaat om databases, zoals bij het opslaan en beheren van belangrijke gegevens. Snelle verwerking, betrouwbaarheid en schaalbaarheid maken MySQL een favoriet bij ontwikkelaars, zeker wanneer er grote hoeveelheden data in het spel zijn. Daarnaast is het schaalbaar is voor zowel kleine websites als uitgebreide zakelijke systemen. Een enthousiaste, actieve community van ontwikkelaars staat altijd klaar om te helpen wanneer je ergens tegenaan loopt.',
            },
            {
                type: 'quote',
                content:
                    'een favoriet bij ontwikkelaars, zeker wanneer er grote hoeveelheden data in het spel zijn.',
            },
            {
                type: 'text',
                title: 'Zakelijk gebruik en data-analyse',
                content: `
                    Op zakelijk gebied biedt MySQL een oplossing voor een hoop uitdagingen. Klantrelatiebeheer (CRM) systemen en enterprise resource planning (ERP) hebben bijvoorbeeld enorme baat bij het efficiënt beheren van essentiële bedrijfsgegevens.
                    <br><br>
                    Daarnaast helpt MySQL op het gebied van data-analyse. In combinatie met business intelligence-tools krijgt jouw organisatie diepgaande inzichten en ontdek je de nieuwste trends. Ook voor IoT-toepassingen, waar gegevens continu worden verzameld, verwerkt MySQL deze gegevens moeiteloos en maakt ze klaar voor verdere analyse.
                    <br><br>
                    En als we over samenwerking spreken, betekent dit ook het integreren van MySQL in bredere platforms zoals een klantportaal of intranet. Deze integratie zorgt voor een vloeiende gebruikerservaring van jouw platform.
                `,
            },
            {
                type: 'case',
                case: 'dnzb',
            },
        ],
        related_services: ['front-end-development', 'back-end-development', 'intranet'],
        contact: {
            title: '',
            employee: 'jack',
        },
    },
    en: {},
};
